// @ts-strict

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AvailableCodeOption } from '../codes-modal.service';

@Component({
  selector: 'app-code-options-checkboxes',
  templateUrl: './code-options-checkboxes.component.html',
  styleUrls: ['./code-options-checkboxes.component.scss']
})
export class CodeOptionsCheckboxesComponent {
  @Output() emitCheckAction = new EventEmitter();
  @Output() emitParamsValue: EventEmitter<{ value: string; systemName: string; hasErrors: boolean }> = new EventEmitter();
  @Input() options: AvailableCodeOption[] = [];

  constructor() {}

  public check(index: number, option: { systemName: string }): void {
    const value = !this.options[index].checked;

    this.emitCheckAction.emit({ systemName: option.systemName, index, checked: value });
  }

  public getParameterValue($event: { value: string; systemName: string; hasErrors: boolean }): void {
    this.emitParamsValue.emit($event);
  }
}
